import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import type { FlightItem } from 'tripPlanner/types/tripItem'
import CornerControls from '../DetailItemCard/common/CornerControls'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import SuggestedFlightSearchPriceAndCTAs from './SuggestedFlightSearchPriceAndCTAs'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const SuggestedFlightLayout = styled.div`
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  padding: ${rem(20)};
  break-inside: avoid-page;

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)} ${rem(40)};
  }
`

const Main = styled.div`
  background-color: ${(props) => props.theme.palette.highlight.secondary.lightBackground};
  padding: ${rem(12)} ${rem(16)};
  
  ${mediaQueryUp.tablet} {
    padding: ${rem(12)} ${rem(24)};
  }
`

const ClearCornerControls = styled.div`
  clear: both;
`

interface Props {
  item: FlightItem
}

function SuggestedFlightSearch({ item }: Props) {
  const intl = useIntl()
  return (
    <SuggestedFlightLayout>
      <Main>
        <CornerControls item={item} />
        <VerticalSpacer gap={8}>
          <BodyTextBlock variant="medium" weight="bold" startIcon={<LinePlaneDepartureIcon />}>
            {intl.formatMessage({
              id: 'TwLw0VlBX0fqEaNniMSO',
              defaultMessage: 'Looks like you haven’t added flights',
              description: 'Message suggesting the user add flights to their trip',
            })}
          </BodyTextBlock>
          <ClearCornerControls>
            <SuggestedFlightSearchPriceAndCTAs item={item} />
          </ClearCornerControls>
        </VerticalSpacer>
      </Main>
    </SuggestedFlightLayout>
  )
}

export default SuggestedFlightSearch
